<template>
    <v-simple-table style="margin:30px 5px">
        <thead>
            <th>#</th>
            <th 
              v-for="(item, index) in fields" 
              :class="titles[item] ? 'text-left' : 'text-right'"
              :key="index"> 
              {{ titles[item] || item  }} 
          </th>
        </thead>
        <tbody>
            <tr v-for="(line, index) in dataRep" :key="index">
                <td style="font-size:18px">{{ index + 1 }}</td>
                <td class="text-left" v-for="(item, index) in fields" 
                    :key="index" style="font-size:16px" 
                    :class="titles[item] ? 'text-left' : 'text-right'">
                   {{ formatValue(item, line) }}
                </td>
            </tr>
        </tbody>
    </v-simple-table>   
</template>

<script>
export default {
  props: {
    dataRep: {
      type: Array,
      default: () => [],
    },
    fields: {
        type: Array,
    }
  },  
  data: () => ({    
    titles: {
          lotPurchased: 'Usuario',  
          username: 'Propietario',
          lotenum: 'Lote',
          manzana: 'Manzana',
          street: 'Calle',
          placeOfResidence: 'Lugar residencia',
          mobilePhone: 'Celular',
          email: 'Correo',
          statusDebt: 'Status financiero',
          legalStatus: 'Status predio',
          contactName: 'Nombre contacto secundario',
          contactEmail: 'Correo contacto secundario',
          contactMobile: 'Celular contacto secundario',
          hasWhats: 'Incluido WhatsApp',
          numPets: 'Número mascotas',
          docuPets: 'Documentación mascotas',
          tag1: 'Tag1',
          tag2: 'Tag2',
          tag3: 'Tag3',         
          sanctions: 'Sanciones', coments: 'Comentarios'          
    }
  }),
  created() {
   console.log(this.fields);
   console.log(this.dataRep[0]);
  },
  methods: {
    formatValue(item, line) {
      const value = line[item];

      // si existe título para este item → devolver tal cual
      if (this.titles[item]) {
        return value;
      }

      // si NO existe → formatear como currency
      if (typeof value === "number") {
        return value.toLocaleString("es-MX", {
          style: "currency",
          currency: "MXN",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
      }

      return value;
    }
  }
}
</script>
<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>